<div id="cover" *ngIf="projectService.loading()"></div>

<div *ngIf="loading" class="row no-data page-center">
    <img src="../../assets/img/no-data.png">
</div>

<div class="tabs-container">
  <div class="root-tabs-bar">
    <div class="tabs-scroll-container">
      <div class="tabs-wrapper" style="background: #dee2e6;">
        <button 
          *ngFor="let form of formSubmissionList; let i = index"
          class="tab-btn root-tab" 
          [class.active]="activeRootTabIndex === i"
          (click)="selectRootTab(i)">
          {{ form?.form_name[0]?.toUpperCase() + form?.form_name?.slice(1)?.toLowerCase()}}
        </button>
      </div>
    </div>
  </div>
  <div class="root-tab-panel">
    <div *ngIf="currentForm?.form_submission.length > 0" class="child-tabs-bar">
      <div class="tabs-scroll-container">
        <div class="tabs-wrapper">
          <button *ngFor="let sub of currentForm?.form_submission; let j = index" class="tab-btn child-tab"
            [class.active]="activeChildTabIndex === j" (click)="selectChildTab(j)">
            <div>{{sub?.created_user_name}} <span [hidden]="activeChildTabIndex !== j" (click)="editEntryForm()" class="edit-entry"><i class="fa-solid fa-pen-to-square"></i></span></div>
            <div>{{sub?.filled_datetime | date:'short'}}</div>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="showEditMode && (currentForm?.form_submission.length!==0)" class="dynamic-form-container">
      <app-dynamic-entry-form #dynamicForm></app-dynamic-entry-form>
    </div>
    <div *ngIf="(currentForm?.form_submission.length===0) && loading" class="empty-state">
          <img src="../../assets/img/no-data.png">
    </div>
  </div>
</div>
<!-- <div class="section-page dashboard">
    <div class="container-fluid">
        <ag-grid-angular *ngIf="rowData.length" class="ag-theme-alpine" [rowData]="rowData" [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
            (firstDataRendered)="onFirstDataRendered($event)" [pagination]="true" style="height: 100%; width: auto;">
        </ag-grid-angular>
    </div>
</div> -->

<!-- <p-dialog [header]="dialogHeader" [(visible)]="commonDataObject.displayDialog" [modal]="true"
    [style]="{ width: '100%', height: '100%' }" (onHide)="commonDataObject.displayDialog = false;">
    <app-dynamic-entry-form (formSaved)="onFormSaved()"
        (formNameChanged)="onFormNameChange($event)"></app-dynamic-entry-form>
</p-dialog> -->

<!-- <p-dialog header="Delete Form Entry" [(visible)]="commonDataObject.deleteDialog" [modal]="true" [closable]="true"
    [style]="{width: '600px'}">
    <div class="row">
        <div class="col-md-12">
            Are you sure you want to delete this Form Entry Details?
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button type="button" class="btn btn-cancel" label="Show" styleClass="p-button-text"
            (click)="commonDataObject.deleteDialog = false">
            No
        </button>
        <button type="button" class="btn btn-first" label="Show" (click)="confirmDelete()"
            styleClass="p-button-text">
            Yes
        </button>
    </ng-template>
</p-dialog> -->